import * as React from 'react'
import classnames from 'classnames'
import Button from 'components/Base/Button'
import * as styles from './index.module.less'
import { string } from 'prop-types'

export enum ClientTypes {
  Type20211220 = styles.Type20211220,
}
interface ClientContentProps {
  title?: string
  desc?: string
  buttonText?: string
  buttonHref?: string
  buttonType?: string
  buttonTarget?: string
  logoUrl?: string
  logoAlt?: string
  logoWidth?: string | number
  logoHeight?: string | number
  logoWall?: string
  logoWallAlt?: string
  style?: React.CSSProperties
  className?: string
  abstract?: React.ReactNode | string
  type?: ClientTypes
}
const ClientContent: React.FC<ClientContentProps> = ({
  title,
  desc,
  buttonText,
  buttonHref,
  buttonType = 'primary',
  buttonTarget = '_blank',
  logoUrl,
  logoAlt,
  logoWidth,
  logoHeight,
  logoWall,
  logoWallAlt,
  style,
  className,
  abstract,
  type,
  children,
}) => {
  const cnames = classnames(styles.ClientContent, className, type)
  return (
    <div className={cnames} style={style}>
      <p className={classnames(styles.Abstract)} style={{ display: abstract ? 'block' : 'none' }}>
        {abstract}
      </p>
      {title && (
        <div className={styles.ClientBody}>
          <div className="left">
            {logoUrl && (
              <img className="logo" src={logoUrl} alt={logoAlt} style={{ height: logoHeight, width: logoWidth }} />
            )}
            <h4>{title}</h4>
            <p>{desc}</p>
            <Button btnType={buttonType} href={buttonHref} target={buttonTarget}>
              {buttonText}
            </Button>
          </div>
          <div className="right">
            <img className="logo-wall" src={logoWall} alt={logoWallAlt} />
            <Button className="right-button" btnType={buttonType} href={buttonHref} target={buttonTarget}>
              {buttonText}
            </Button>
          </div>
        </div>
      )}
      {children}
    </div>
  )
}

export default ClientContent
